import React from 'react';
import PropTypes from 'prop-types';

// Mui
import { styled } from '@mui/material/styles';
import MuiPagination from '@mui/material/Pagination';
import TablePagination from '@mui/material/TablePagination';

const StyledTablePagination = styled(TablePagination)({
  '& .MuiTablePagination-toolbar': {
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
});

const PaginationActions = ({ count, page, rowsPerPage, onPageChange, disabled }) => {
  const pageCount = Math.ceil(count / rowsPerPage);

  return (
    <MuiPagination
      color="primary"
      count={pageCount}
      page={page + 1}
      size="small"
      shape="rounded"
      showFirstButton
      showLastButton
      disabled={disabled}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
};

const PaginationContainer = ({
  resourceName = '',
  list,
  loading,
  current_page = 0,
  total_count = 0,
  total_pages = 0,
  per_page = 10,
  rowsPerPageOptions = [10, 25, 50, 100, 250],
}) => {
  const page = current_page > 0 ? current_page - 1 : 0;

  const handleChangePage = (event, newPage) => {
    if (loading) return;
    const apiPage = newPage + 1;
    list({ page: apiPage, per_page });
  };

  const handleChangeRowsPerPage = (event) => {
    if (loading) return;
    const newPerPage = parseInt(event.target.value, 10);
    list({ page: 1, per_page: newPerPage });
  };

  const showPagination = total_count > 0;

  const paginationProps = {
    ActionsComponent: PaginationActions,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    count: total_count,
    page,
    rowsPerPage: per_page,
    rowsPerPageOptions,
    SelectProps: {
      disabled: loading,
    },
    slotProps: {
      actions: {
        disabled: loading,
      },
    },
  };

  return (
    <>
      {showPagination && (
        <div style={{ paddingBottom: 80 }}>
          <StyledTablePagination component="div" {...paginationProps} />
        </div>
      )}
    </>
  );
};

PaginationContainer.propTypes = {
  list: PropTypes.func.isRequired,
  resourceName: PropTypes.string,
  total_count: PropTypes.number,
  total_pages: PropTypes.number,
  current_page: PropTypes.number,
  per_page: PropTypes.number,
};

export default PaginationContainer;
